/* Mozavel Upsell — In-Cart recommendations + "Häufig zusammen gekauft" bundle.
   Context-aware via Shopify product recommendations. No external app. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var fmt;
  try { fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: cur }); }
  catch (e) { fmt = { format: function (n) { return n.toFixed(2).replace('.', ',') + ' €'; } }; }
  function money(c) { return fmt.format((c || 0) / 100); }
  function thumb(url, w) {
    if (!url) return '';
    return url.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i, '_' + w + 'x$1$2');
  }
  function firstAvail(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) { if (vs[i].available) return vs[i]; }
    return vs[0];
  }
  async function addItems(items) {
    var res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    });
    if (!res.ok) throw new Error('add failed');
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    return res.json();
  }
  function openDrawer() {
    var t = document.querySelector('[aria-controls="cart-drawer"]');
    if (t) setTimeout(function () { t.click(); }, 180);
  }
  async function getRecs(pid, limit) {
    try {
      var r = await fetch(root + 'recommendations/products.json?product_id=' + pid + '&intent=related&limit=' + limit);
      var d = await r.json();
      return d.products || [];
    } catch (e) { return []; }
  }
  async function getCart() {
    try { return await (await fetch(root + 'cart.js')).json(); } catch (e) { return { items: [] }; }
  }

  /* ---------- IN-CART UPSELL ---------- */
  class MozCartUpsell extends HTMLElement {
    async connectedCallback() {
      if (this._init) return; this._init = true;
      var cart = await getCart();
      if (!cart.items || !cart.items.length) { this.remove(); return; }
      var base = cart.items[0].product_id;
      var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
      var recs = await getRecs(base, 8);
      recs = recs.filter(function (p) { return !inCart[p.id] && firstAvail(p) && firstAvail(p).available; }).slice(0, 3);
      if (!recs.length) { this.remove(); return; }
      this.render(recs);
    }
    render(recs) {
      var title = this.getAttribute('data-title') || 'Complétez votre commande';
      var html = '<div class="moz-ups"><p class="moz-ups__title">' + title + '</p><div class="moz-ups__row">';
      recs.forEach(function (p) {
        var v = firstAvail(p); if (!v) return;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        html += '<div class="moz-ups__card">'
          + '<a href="' + p.url + '" class="moz-ups__imgwrap">' + (img ? '<img src="' + thumb(img, 160) + '" alt="" loading="lazy">' : '') + '</a>'
          + '<div class="moz-ups__info"><a href="' + p.url + '" class="moz-ups__name">' + p.title + '</a>'
          + '<span class="moz-ups__price">' + money(v.price) + '</span></div>'
          + '<button type="button" class="moz-ups__add" data-vid="' + v.id + '" aria-label="Ajouter">+</button>'
          + '</div>';
      });
      html += '</div></div>';
      this.innerHTML = html;
      this.querySelectorAll('.moz-ups__add').forEach(function (b) {
        b.addEventListener('click', async function () {
          b.disabled = true; b.classList.add('is-done'); b.textContent = '✓';
          try { await addItems([{ id: Number(b.dataset.vid), quantity: 1 }]); }
          catch (e) { b.disabled = false; b.classList.remove('is-done'); b.textContent = '+'; }
        });
      });
    }
  }
  if (!customElements.get('mozavel-cart-upsell')) customElements.define('mozavel-cart-upsell', MozCartUpsell);

  /* ---------- "HÄUFIG ZUSAMMEN GEKAUFT" (FBT) ---------- */
  class MozFbt extends HTMLElement {
    async connectedCallback() {
      if (this._init) return; this._init = true;
      var pid = this.getAttribute('data-product-id');
      var list = this.querySelector('.moz-fbt__list');
      var totalEl = this.querySelector('.moz-fbt__total-val');
      var btn = this.querySelector('.moz-fbt__btn');
      var recs = await getRecs(pid, 4);
      recs = recs.filter(function (p) { return firstAvail(p) && firstAvail(p).available; }).slice(0, 2);
      if (!recs.length) { this.remove(); return; }
      recs.forEach(function (p) {
        var v = firstAvail(p); if (!v) return;
        var img = p.featured_image || '';
        var el = document.createElement('label');
        el.className = 'moz-fbt__item';
        el.innerHTML = '<span class="moz-fbt__plus">+</span>'
          + '<input type="checkbox" class="moz-fbt__cb" data-vid="' + v.id + '" data-price="' + v.price + '" checked>'
          + '<a href="' + p.url + '" class="moz-fbt__thumb">' + (img ? '<img src="' + thumb(img, 160) + '" alt="">' : '') + '</a>'
          + '<span class="moz-fbt__meta"><a href="' + p.url + '" class="moz-fbt__name">' + p.title + '</a>'
          + '<span class="moz-fbt__price">' + money(v.price) + '</span></span>';
        list.appendChild(el);
      });
      var self = this;
      function recompute() {
        var total = 0;
        self.querySelectorAll('.moz-fbt__cb').forEach(function (cb) { if (cb.checked) total += Number(cb.dataset.price); });
        totalEl.textContent = money(total);
      }
      this.querySelectorAll('.moz-fbt__cb').forEach(function (cb) { cb.addEventListener('change', recompute); });
      recompute();
      btn.addEventListener('click', async function () {
        var items = [];
        self.querySelectorAll('.moz-fbt__cb').forEach(function (cb) {
          if (!cb.checked) return;
          var vid = cb.dataset.vid;
          if (cb.dataset.current === '1') {
            var sel = document.querySelector('.product-info [name="id"], product-form [name="id"], form[action$="/cart/add"] [name="id"]');
            if (sel && sel.value) vid = sel.value;
          }
          items.push({ id: Number(vid), quantity: 1 });
        });
        if (!items.length) return;
        btn.disabled = true; var t = btn.textContent; btn.textContent = 'Ajout en cours…';
        try { await addItems(items); openDrawer(); btn.textContent = '✓ Ajouté'; }
        catch (e) { btn.disabled = false; btn.textContent = t; }
      });
    }
  }
  if (!customElements.get('mozavel-bundle')) customElements.define('mozavel-bundle', MozFbt);

  /* ---------- STYLES (injected once) ---------- */
  if (!document.getElementById('moz-upsell-css')) {
    var s = document.createElement('style');
    s.id = 'moz-upsell-css';
    s.textContent = [
      /* in-cart */
      '.moz-ups{margin:1rem 1.25rem;padding-top:1rem;border-top:1px solid #ececec}',
      '.moz-ups__title{font-size:.95rem;font-weight:600;color:#1B2A4A;margin:0 0 .7rem}',
      '.moz-ups__row{display:flex;flex-direction:column;gap:.7rem}',
      '.moz-ups__card{display:flex;align-items:center;gap:.7rem}',
      '.moz-ups__imgwrap{flex:0 0 auto;width:52px;height:64px;border-radius:8px;overflow:hidden;background:#f5f5f5}',
      '.moz-ups__imgwrap img{width:100%;height:100%;object-fit:cover;display:block}',
      '.moz-ups__info{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:.15rem}',
      '.moz-ups__name{font-size:.85rem;color:#1B2A4A;text-decoration:none;line-height:1.25;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
      '.moz-ups__price{font-size:.85rem;font-weight:600;color:#1B2A4A}',
      '.moz-ups__add{flex:0 0 auto;width:34px;height:34px;border-radius:50%;border:1px solid #1B2A4A;background:#fff;color:#1B2A4A;font-size:1.3rem;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:.15s}',
      '.moz-ups__add:hover{background:#1B2A4A;color:#fff}',
      '.moz-ups__add.is-done{background:#2f9e2f;border-color:#2f9e2f;color:#fff;font-size:1rem}',
      /* fbt */
      '.moz-fbt{max-width:820px;margin:0 auto;padding:1.4rem 1.4rem 1.5rem;border:1px solid #e6e8ec;border-radius:14px}',
      '.moz-fbt__title{font-size:1.15rem;font-weight:600;color:#1B2A4A;margin:0 0 1rem;text-align:center}',
      '.moz-fbt__list{display:flex;flex-wrap:nowrap;align-items:stretch;gap:1rem;justify-content:center;overflow-x:auto;scroll-snap-type:x proximity;padding:.2rem .2rem 1rem;-webkit-overflow-scrolling:touch}',
      '.moz-fbt__list::-webkit-scrollbar{height:6px}.moz-fbt__list::-webkit-scrollbar-track{background:transparent}.moz-fbt__list::-webkit-scrollbar-thumb{background:#dfe3ea;border-radius:3px}',
      '.moz-fbt__item{position:relative;flex:0 0 auto;scroll-snap-align:center;display:flex;flex-direction:column;align-items:center;gap:.4rem;width:150px;padding:.6rem;border:1px solid #eef0f3;border-radius:12px;cursor:pointer;background:#fff}',
      '.moz-fbt__item--current{border-color:#1B2A4A}',
      '.moz-fbt__plus{position:absolute;left:-.75rem;top:50%;transform:translateY(-50%);z-index:2;color:#9aa3b2;font-size:1.25rem;font-weight:400}',
      '.moz-fbt__item:first-child .moz-fbt__plus{display:none}',
      '.moz-fbt__cb{position:absolute;top:.5rem;right:.5rem;width:18px;height:18px;accent-color:#1B2A4A;cursor:pointer}',
      '.moz-fbt__thumb{display:block;width:110px;height:130px;border-radius:8px;overflow:hidden;background:#f5f5f5}',
      '.moz-fbt__thumb img{width:100%;height:100%;object-fit:cover;display:block}',
      '.moz-fbt__meta{display:flex;flex-direction:column;align-items:center;gap:.2rem;text-align:center}',
      '.moz-fbt__name{font-size:.82rem;color:#1B2A4A;text-decoration:none;line-height:1.25;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
      '.moz-fbt__price{font-size:.9rem;font-weight:600;color:#1B2A4A}',
      '.moz-fbt__thisone{font-size:.68rem;color:#8a90a0;text-transform:uppercase;letter-spacing:.04em}',
      '.moz-fbt__foot{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:.6rem 1.2rem;margin-top:1.2rem}',
      '.moz-fbt__total{font-size:1rem;color:#1B2A4A}.moz-fbt__total-val{font-weight:700}',
      '.moz-fbt__btn{background:#26334D;color:#fff;border:0;border-radius:10px;padding:.8rem 1.6rem;font-size:.95rem;font-weight:600;cursor:pointer;transition:.15s}',
      '.moz-fbt__btn:hover{background:#1B2A4A}.moz-fbt__btn:disabled{opacity:.7;cursor:default}',
      '@media(max-width:600px){.moz-fbt__item{width:132px}.moz-fbt__thumb{width:100px;height:118px}}'
    ].join('');
    document.head.appendChild(s);
  }
})();

/* Mozavel — re-filter product gallery by color on client-side variant change.
   Prestige filters via #Farbe_<color> alt only on load; this keeps it in sync when
   the shopper clicks a color swatch without a page reload. */
(function () {
  function colorFromAlt(alt) {
    if (!alt || alt.indexOf('#') < 0) return null;
    var after = alt.split('#').pop();          // "Farbe_Rostrot"
    var parts = after.split('_');
    if (parts.length < 2) return null;
    return parts.slice(1).join('_').trim().toLowerCase();
  }
  function selectedColor(variant) {
    if (!variant) return null;
    var v = (variant.options && variant.options[0]) || variant.option1 || null;
    return v ? String(v).trim().toLowerCase() : null;
  }
  function filterGallery(color) {
    if (!color) return;
    var nodes = document.querySelectorAll('.product-gallery__media, .product-gallery__thumbnail');
    nodes.forEach(function (el) {
      var img = el.querySelector('img');
      var c = colorFromAlt(img ? img.getAttribute('alt') : '');
      if (c) el.toggleAttribute('hidden', c !== color);   // media w/o color tag stay visible
    });
  }
  document.addEventListener('variant:change', function (e) {
    var color = selectedColor(e.detail && e.detail.variant);
    if (color) setTimeout(function () { filterGallery(color); }, 30);
  });
})();
